import axios from "axios";
import config from "../Config.json";


const FetchUserDetails = async(id) => {
    try {
        const AuthToken = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = AuthToken;       
        const response = await axios.get(`${config.API_URL}/app/userdetail/${id}`, )
        return response
    } catch (error) {
        return error
    }
}

export default FetchUserDetails